import React from "react";
import { money } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, Trash2 } from "lucide-react";

const METHODS = [["cash", "Cash"], ["upi", "UPI"], ["card", "Card"], ["bank_transfer", "Bank Transfer"], ["netbanking", "Net Banking"], ["cheque", "Cheque"]];

export function PaymentSplits({ splits, setSplits, grand }) {
  const paid = splits.reduce((a, s) => a + Number(s.amount || 0), 0);
  const balance = +(grand - paid).toFixed(2);
  const upd = (i, k, v) => setSplits(splits.map((s, j) => j === i ? { ...s, [k]: v } : s));
  return (
    <div className="space-y-2 pt-2 border-t" data-testid="di-payment-splits">
      <div className="flex items-center justify-between">
        <span className="text-sm font-semibold text-slate-700">Amount Received</span>
        <label className="flex items-center gap-1 text-xs text-slate-500">
          <input type="checkbox" checked={splits.length > 0 && balance === 0} data-testid="di-fully-paid"
            onChange={(e) => setSplits(e.target.checked ? [{ method: splits[0]?.method || "cash", amount: +grand.toFixed(2) }] : [])} /> Fully paid
        </label>
      </div>
      {splits.map((s, i) => (
        <div key={i} className="grid grid-cols-[130px_1fr_36px] gap-2 items-center">
          <Select value={s.method} onValueChange={(v) => upd(i, "method", v)}>
            <SelectTrigger className="h-8" data-testid={`di-split-method-${i}`}><SelectValue /></SelectTrigger>
            <SelectContent className="bg-white">{METHODS.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
          </Select>
          <Input type="number" min="0" value={s.amount} onChange={(e) => upd(i, "amount", Math.max(0, Number(e.target.value)))} className="h-8 text-right font-mono" data-testid={`di-split-amount-${i}`} />
          <Button size="icon" variant="ghost" className="h-8 w-8" onClick={() => setSplits(splits.filter((_, j) => j !== i))}><Trash2 className="h-4 w-4 text-red-500" /></Button>
        </div>
      ))}
      <Button size="sm" variant="ghost" className="text-[#1A2A5E] px-0" data-testid="di-add-split"
        onClick={() => setSplits([...splits, { method: splits.length ? "upi" : "cash", amount: Math.max(0, balance) }])}><Plus className="h-4 w-4 mr-1" />{splits.length ? "Split payment" : "Add payment"}</Button>
      <div className={`flex justify-between font-semibold ${balance < 0 ? "text-rose-600" : "text-slate-700"}`}>
        <span>{balance < 0 ? "Excess received" : "Balance Due"}</span><span className="font-mono" data-testid="di-balance">{money(Math.abs(balance))}</span>
      </div>
    </div>
  );
}
